import { SELECIONAR_TIPOS_EMISSOES } from '../types'

export default function selecionartiposEmissoes (tipos) {
  return {
    type: SELECIONAR_TIPOS_EMISSOES,
    payload: tipos
  }
}
